/* ========================================================
   H.OLA - SOSYAL MEDYA LİNKLERİ YENİ SEKME (KESİN ÇÖZÜM)
======================================================== */
function setSocialLinksTarget(event) {
  var socialLink = event.target.closest('.footer__block-social-icons a');
  if (socialLink) {
    socialLink.setAttribute('target', '_blank');
    socialLink.setAttribute('rel', 'noopener noreferrer');
  }
}

// Mouse ile üzerine gelindiğinde anında uygula (Masaüstü)
document.addEventListener('mouseover', setSocialLinksTarget);

// Parmağıyla dokunmaya başladığı an uygula (Mobil)
document.addEventListener('touchstart', setSocialLinksTarget, {passive: true});



document.addEventListener('click', function(e) {
  const btn = e.target.closest('#byob-bundle-summary .summary-primary-button');
  if (!btn) return;
  document.querySelector('#byob-bundle-summary')?.classList.add('byob-submitting');
});


/* ============================================
   Slider tema sistemi - body class değişimi
   ============================================ */
(function() {
  const sliderSection = document.querySelector('[data-section-name="slider"]');
  if (!sliderSection) return;

  function updateTheme() {
    const activeSlide = sliderSection.querySelector('.swiper-slide-active');
    if (!activeSlide) return;
    const theme = activeSlide.dataset.slideTheme || 'dark';
    document.body.classList.remove('slider-theme-light', 'slider-theme-dark');
    document.body.classList.add('slider-theme-' + theme);
  }

  // İlk yüklemede çalıştır (slider hazır olduktan sonra)
  setTimeout(updateTheme, 500);

  // Slide değişimini izle
  const observer = new MutationObserver(function(mutations) {
    for (const m of mutations) {
      if (m.attributeName === 'class' && m.target.classList.contains('swiper-slide-active')) {
        updateTheme();
        break;
      }
    }
  });

  sliderSection.querySelectorAll('.swiper-slide').forEach(slide => {
    observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
  });
})();

/* ============================================
   Slider geçildikten sonra menü = altın
   ============================================ */
(function() {
  const sliderSection = document.querySelector('[data-section-name="slider"]');
  if (!sliderSection) return;

  function updateScrollState() {
    const rect = sliderSection.getBoundingClientRect();
    // Slider'ın alt kenarı header bölgesini (~100px) geçtiyse
    const headerOffset = 100;
    if (rect.bottom < headerOffset) {
      document.body.classList.add('scrolled-past-slider');
    } else {
      document.body.classList.remove('scrolled-past-slider');
    }
  }

  // Performans için throttle (scroll çok hızlı tetiklenir)
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateScrollState();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // İlk yüklemede de kontrol et
  updateScrollState();
})();

document.addEventListener('DOMContentLoaded', function () {
  const ratingWrappers = document.querySelectorAll(
    '.rating-wrapper:not([data-rating-count="0"])'
  );

  ratingWrappers.forEach(function (wrapper) {
    wrapper.style.cursor = 'pointer';
    wrapper.addEventListener('click', function () {
      const reviewsSection = document.querySelector(
        '#judgeme_product_reviews, #shopify-product-reviews, .shopify-product-reviews'
      );
      if (reviewsSection) {
        reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});